<template>
  <v-container>
    <v-card v-if="selectedDashboard.participationCounts">
      <v-layout column>
        <v-flex style>
          <v-row class="optionsBox">
            <v-col class="dropdown" v-if="getCampaignId">
              <v-autocomplete
                v-model="selectedCampaignId"
                :items="selectableCampaigns"
                item-text="text"
                item-value="symbol"
                label="Select Campaign Id"
              >
              </v-autocomplete>
            </v-col>
            <v-col style="max-width: 10%">
              <v-checkbox
                v-model="allRetailer"
                label="All Retailer"
              ></v-checkbox>
            </v-col>
            <v-col class="dropdown" v-if="retailers && !allRetailer">
              <v-autocomplete
                v-model="selectedRetailer"
                :items="retailers"
                item-text="name"
                item-value="id"
                label="Select Retailer"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="searchBox">
              <v-row>
                <v-btn
                  class="button"
                  color="blue darken-2"
                  :disabled="isPending"
                  @click="getCounts()"
                  >Search
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
      <v-layout column v-if="showData">
        <v-flex style>
          <v-row class="optionsBox">
            <v-col md="4" class="col-xs-12">
              <widget
                icon="mdi-checkbox-marked-circle"
                :title="totals.confirmed"
                subTitle="Accepted"
                color="#8bc34a"
              />
            </v-col>
            <v-col md="4" class="col-xs-12">
              <widget
                icon="mdi-close-circle"
                :title="totals.rejected"
                subTitle="Rejected"
                color="#ff5722"
              />
            </v-col>
            <v-col md="4" class="col-xs-12">
              <widget
                icon="mdi-clipboard-plus"
                :title="totals.preConfirmed"
                subTitle="Pre-Confirmed"
                color="#607d8b"
              />
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-card>
    <v-card v-else>
      <v-layout column>
        <v-flex style>
          <v-alert
            :value="true"
            icon="mdi-cancel"
            class="display-1 font-weight-thin"
            >Participation Counts has not yet been added for this campaign.
            ¯\_(ツ)_/¯</v-alert
          >
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  components: {
  },
  watch: {
    showDialog(val) {
      console.log("SHoW DiaLOG Watch 2", val);
      if (val === false) {
        this.receiptImageElement = null;
        this.receiptImageIsLoading = true;
        this.img = new Image();
      }
    },
    searchReceiptId(val) {
      this.searchForReceipt(this.infiniteState);
    },
    searchCampaignId(val) {
      this.searchForReceipt(this.infiniteState);
    },
    searchDashboarderId(val) {
      this.searchForReceipt(this.infiniteState);
    }
  },
  data() {
    return {
      isPending: false,
      showData: false,
      selectableCampaigns: [],
      selectedCampaignId: "",
      selectedRetailer: "",
      retailers: [],
      allRetailer: false,
      totals: {
        confirmed: 0,
        rejected: 0,
        preConfirmed: 0
      }
    };
  },
  computed: {
    ...mapGetters(["userToken", "selectedDashboard"]),
    getCampaignId: {
      get() {
        if (this.selectedDashboard.campaignId === "pg-template") {
          this.selectableCampaigns = [
            { text: "lenor-wama", value: "" },
            { text: "always-3.0-testwochen", value: "" },
            { text: "lenor-pm", value: "" },
            { text: "fairy-testen", value: "" },
            { text: "febreze-testen", value: "" },
            { text: "ariel-pledge", value: "" },
            { text: "bad-testen", value: "" },
            { text: "pg-professional", value: "" },
            { text: "gillette-testen", value: "" },
            { text: "pgp-metro", value: "" },
            { text: "oralb-testen", value: "" },
            { text: "un-2.0-testen", value: "" },
            { text: "lenor-sensitiv", value: "" },
            { text: "oldspice-2.0-testwochen", value: "" },
            { text: "always-liners", value: "" },
            { text: "always-nigthpads", value: "" }
          ];
        } else if (this.selectedDashboard.campaignId === "pg-ro") {
          this.selectableCampaigns = [{ text: "pg-youtil-ro", value: "" }, { text: "pg-charity-ro", value: "" }, { text: "pampers-auchan-ro", value: "" }];
        } else if (this.selectedDashboard.campaignId === "pg-turkey") {
          this.selectableCampaigns = [{ text: "firsat-yaninda", value: "" }, { text: "firsat-yaninda-olimpiyat", value: "" }];
        } else if (this.selectedDashboard.campaignId === "FB-BOT") {
          this.selectableCampaigns = [{ text: "tuc-bot-ro", value: "" }];
        } else {
          this.selectableCampaigns = []
        }
        return true;
      }
    }
  },
  methods: {
    ...mapActions(['errorHandler']),
    getCounts() {
      this.isPending = true;
      this.showData = true;
      const retailer = this.allRetailer ? false : this.selectedRetailer;
      axios
        .post(`${this.selectedDashboard.endPoints.base}/participationCounts`, {
          sessid: this.userToken,
          campaignId: this.selectedCampaignId,
          retailer
        })
        .then((response) => {
          if (response.data.response) {
            this.totals = response.data.totals;
            this.isPending = false;
          } else {
            this.errorHandler(response.data.message || response.data.error)
          }
        })
        .catch((er) => {
          this.errorHandler(er)
        });
    }
  },
  created () {
    axios.get(`${this.selectedDashboard.endPoints.base}/getRetailers/${this.userToken}`)
      .then((response) => {
        if (response.data.response) {
          this.retailers = response.data.retailers;
        } else {
          this.retailers = [];
        }
      })
      .catch((er) => {
        this.errorHandler(er.response)
      });
  },
  mounted() {
    if ("name" in this.selectedDashboard === false) {
      const dashboard = JSON.parse(localStorage.selectedDashboard);
      this.$store.commit("setDashboard", dashboard);
    }
    this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));
  }
};
</script>

<style scoped>
.optionsBox {
  margin-left: 12px;
  margin-right: 12px;
  margin-top: 12px;
}
.dropdown {
  max-width: 50%;
}
.searchBox {
  max-width: 30%;
  display: flex;
  align-items: center;
}
.buttonFooter {
  margin-top: 20px;
  margin-bottom: 20px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
